var cred = new Credentials();

$(document).ready(function() {
    logMsg('Hello. Starting up the login screen.');

    // Login:
    $('#intro button').click(doIntroButton);
    $('.forgot').click(doForgot);
    $('.cancel').click(doCancel);

    // Form validation:
    jQueryValidationBootstrapPatch();
    $('#loginWithCredentials').validate({
        rules: {
            pwd: {
                minlength: 6,
                required: true
            }
        },
        messages: {
            pwd: {
                minlength: 'Your password must be at least 6 characters.'
            }
        },
        submitHandler: doLoginSubmit
    });
    $('#loginWithBirthdate').validate({
        rules: {
            lname: {
                required: true,
                minlength: 2
            },
            birthdate: {
                required: true,
                date: true,
                pattern: /^\d{1,2}[\/\-]\d{1,2}[\/\-](\d\d|\d\d\d\d)$/
            }
        },
        submitHandler: doLoginSubmit
    });
});

/*
 *
 *		INTRO SCREEN
 *
 */

// Initializes login form based on which button was pushed on intro screen.
function doIntroButton() {
    $('#intro').hide();
    logMsg('Go to login form for ' + this.value + '-accounts!');
    initLoginForm(this.value);
    return false;
}

/*
 *
 *		LOGIN SCREEN(S)
 *
 */

// Cancel button just clears out the form and goes back to intro screen.
function doCancel() {
    logMsg('Canceling, go back to intro form.');
    $('.loginform').hide();
    $('#intro').show();
    resetLoginForm();
    return false;
}

// Forgot button will open password self-service page for appropriate user type
function doForgot() {
    var which = $('.loginform:visible').attr('data-type');
    var fs = loginFormSettings[which];
    logMsg('Forgot Password clicked.');
    if (confirm('We can help you reset your password. Would you like to reset your password now?'))
        window.open(fs.pwdurl);
    return false;
}

// Login form submit handler sends credentials to appropriate authentication web service.
function doLoginSubmit() {
    var $form = $(this.currentForm);
    var which = $form.attr('data-type');
    var fs = loginFormSettings[which];
    var parms = {
        method: fs.wsmethod,
        returnFormat: 'json'
    };
    cred.pullFromLoginForm($form);
    cred.injectIntoObject(parms);
    logMsg("Okay! Let's try logging in " + cred.id + '!');
    $('.loginform:visible button[type=submit]')
        .ladda()
        .ladda('start');
    $.ajax({
        dataType: 'json',
        url: fs.wsurl,
        method: 'POST',
        data: parms,
        cache: false,
        success: handleLoginSubmit,
        error: handleLoginError
    });
}

// Login form handler for web service errors.
function handleLoginError(qXHR, textStatus, errorThrown) {
    $('.loginform:visible button[type=submit]').ladda('stop');
    alert('Sorry, there was a problem while attempting to login!\n\n' + errorThrown);
    resetLoginForm();
}

// Receives data from authentication web service and acts accordingly based on 1. Success, 2. Authenticated but no access, 3. Bad credentials.
function handleLoginSubmit(data) {
    var which = $('.loginform:visible').attr('data-type');
    var fs = loginFormSettings[which];
    logMsg('Login success? ' + data.RESULT + '. Authenticated? ' + data.AUTHRESULTS.AUTHSUCCESSFUL);
    if (data.RESULT) {
        logMsg('Sending them to registration form.');
        initRegForm(which);
    } else if (data.AUTHRESULTS.AUTHSUCCESSFUL) {
        logMsg('Authentication successful but no access. ' + fs.noaccessmsg);
        $('.loginform:visible button[type=submit]').ladda('stop');
        alert(fs.noaccessmsg);
        resetLoginForm();
    } else {
        logMsg('Authentication failed.');
        $('.loginform:visible button[type=submit]').ladda('stop');
        alert('The information you supplied does not match our records.');
        resetLoginForm();
    }
}

// Sets up appropriate login screen, sets validation and other UI.
function initLoginForm(which) {
    $(which == 'nc' ? '#loginWithBirthdate' : '#loginWithCredentials')
        .show()
        .attr('data-type', which);
    var fs = loginFormSettings[which];
    if (fs.hasOwnProperty('validation')) {
        $('#id').rules('remove');
        $('#id').rules('add', fs.validation);
    }
    $('.loginform .e, .loginform .g, .loginform .s').hide();
    $('.loginform .' + which).show();
    resetLoginForm();
}

// Just the UI to reset when clearing a login form, even if it's already initialized but password was bad, for example.
function resetLoginForm() {
    var which = $('.loginform:visible').attr('data-type');
    var fs = loginFormSettings[which];
    if (typeof fs != 'undefined')
        $(fs.focus)
            .focus()
            .select();
    $('.loginform input').val('');
    $('.loginform .has-feedback').removeClass('has-success has-error');
    $('.loginform .help-block').hide();
    $('.loginform .form-control-feedback').removeClass('glyphicon-ok glyphicon-remove');
}
